module.exports = __webpack_public_path__ + "static/aerospace-dark-04ae38821dfd816810996e1adde39ad3.svg";